import { memo } from 'react';

import useSupportedAsset from '@hooks/useSupportedAsset';
import useWalletBalance from '@hooks/useWalletBalance';
import useXTonicBalance from '@hooks/useXTonicBalance';
import { BoostType } from '@hooks/useGetXTonicBoostDailyDistributeRate';
import useVaultDeposits from '@hooks/useVaultDeposits';

import XTonicBeforeBoosting from './XTonicBeforeBoosting';
import XTonicBoosted from './XTonixBoosted';
import NOXTonicBeforeBoosting from './NOXTonicBeforeBoosting';
import { useGetUserBoostCollections } from './XTonicBoostingHooks';

const XTonicBoost = () => {
  const tonicAsset = useSupportedAsset('TONIC');
  const { data: walletBalanceData } = useWalletBalance('MAIN', tonicAsset);

  const xTonicBalance = useXTonicBalance();
  const {
    data: boostedSupplyCollections,
    refetch: refetchBoostedSupplyCollections,
  } = useGetUserBoostCollections(BoostType.SUPPLY);
  const {
    data: boostedBorrowCollections,
    refetch: refetchBoostedBorrowCollections,
  } = useGetUserBoostCollections(BoostType.BORROW);

  const hasXTonic = !xTonicBalance.isZero();

  const { data } = useVaultDeposits();
  const xTonicLocked = data?.some((deposit) => deposit.amount.gt(0));

  const getRenderCard = () => {
    const hasTonic = walletBalanceData?.balance?.gt(0) ?? false;

    const hasBoosted =
      (boostedSupplyCollections && boostedSupplyCollections?.length > 0) ||
      (boostedBorrowCollections && boostedBorrowCollections?.length > 0);

    switch (true) {
      case !hasXTonic && !xTonicLocked:
        return <NOXTonicBeforeBoosting hasTonic={hasTonic} />;
      case xTonicLocked && !hasBoosted:
        return (
          <XTonicBeforeBoosting
            refetchBoostedSupplyCollections={refetchBoostedSupplyCollections}
            refetchBoostedBorrowCollections={refetchBoostedBorrowCollections}
          />
        );
      default:
        return (
          <XTonicBoosted
            boostedSupplyCollections={boostedSupplyCollections}
            boostedBorrowCollections={boostedBorrowCollections}
            refetchBoostedSupplyCollections={refetchBoostedSupplyCollections}
            refetchBoostedBorrowCollections={refetchBoostedBorrowCollections}
          />
        );
    }
  };

  return <>{getRenderCard()}</>;
};

export default memo(XTonicBoost);
